export const TEXTS = {
  EMPTY_CARD_TEXT: 'Оплата по карте',
};
